import axios from "axios";

const API_URL = process.env.VUE_APP_ROOT_API;

import encryptData from "@/helpers/EncryptData";
import errorHandler from "@/helpers/ErrorHandler";

class AuthService {
  async login(user) {
    this.logout();
    return await axios
      .post(
        API_URL + "user/crm/login",
        encryptData({
          email: user.email,
          password: user.password,
        })
      )
      .then((response) => {
        if (response.data.access) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  async loginWithOTP(user) {
    this.logout();
    const { id, otp, processFor } = user;
    let data = { email_otp: otp };
    if (processFor == "mobile") {
      data = { mobile_otp: otp };
    }
    return await axios
      .patch(API_URL + "user/crm/login-wia-otp/" + id, encryptData(data))
      .then((response) => {
        if (
          response.data.is_verify_email_otp_number ||
          response.data.is_verify_mobile_otp_number
        ) {
          if (response.data.user_data.access) {
            localStorage.setItem(
              "user",
              JSON.stringify(response.data.user_data)
            );
          }
        }
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }

  async refreshToken(token) {
    return await axios
      .post(API_URL + "user/token/refresh", {
        refresh: token,
      })
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        localStorage.clear();
        window.location.reload();
      });
  }

  logout() {
    localStorage.clear();
  }
}

export default new AuthService();
